import { IntegrationConfigLayout } from '../layout/IntegrationConfigLayout';
import { useRequiredParams } from '@hooks';
import { useAppGetIntegration } from '@api';
import { Loader } from '@components';
import { ErrorPage } from '@pages';
import { ConfigInfo } from '@Integrations/organisms/IntegrationConfigForm/ConfigInfo';
import { ConnectorFormSection } from '@Integrations/IntegrationConfigForm/organisms/FormSections/ConnectorFormSection';
import { useForm } from 'react-hook-form';

export function EditIntegrationForm() {
  const { id } = useRequiredParams(['id']);
  const { integrationConfig: config, isIntegrationFetched } = useAppGetIntegration(id);
  const { handleSubmit, control } = useForm({
    mode: 'onSubmit',
    defaultValues: { selectedConnectorId: '' },
  });

  const onSubmit = () => {
    // here we will handle the form submit
  };

  if (!isIntegrationFetched) return <Loader />;

  if (!config) return <ErrorPage errorCode={404} errorMessage="Integration not found" />;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <IntegrationConfigLayout sideInfo={<ConfigInfo info={config.info} links={config.links} />}>
        <ConnectorFormSection config={config} control={control} />
      </IntegrationConfigLayout>
    </form>
  );
}
